import React from 'react';

/**
 * Shared spinner — one loader instead of the 5 duplicate `@keyframes spin`
 * definitions the audit found. Respects prefers-reduced-motion via the global
 * rule in Style.scss.
 */
export default function Spinner({ size = 24, label = 'Loading', inline = false }) {
  const spinner = (
    <span
      role="status"
      aria-label={label}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        border: `${Math.max(2, Math.round(size / 10))}px solid rgba(255,255,255,0.25)`,
        borderTopColor: 'var(--accent, #4c8bf5)',
        borderRadius: '50%',
        animation: 'trnd-spin 0.8s linear infinite',
      }}
    />
  );

  const keyframes = (
    <style>{`@keyframes trnd-spin { to { transform: rotate(360deg); } }`}</style>
  );

  if (inline) {
    return (<>{keyframes}{spinner}</>);
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      {keyframes}
      {spinner}
    </div>
  );
}
